module.exports = __webpack_public_path__ + "img/banner-def.2c0ee315.jpg";